export default [
	{
		path: '/test',
		name: 'test',
		props: true,
		meta: {
			title: '测试页'
		},
		component: () => import( '@/views/test/index.vue' ),
	},
]
